<template>
    <div class="@container/collaboration flex flex-col gap-5">
        <div
            v-if="card.archetypes"
            class="grid grid-cols-2 items-center gap-3 rounded-lg bg-surface-sunken p-5 @2xs/collaboration:grid-cols-[1fr_auto_1fr]"
            :aria-label="t('chat.collaboration.archetypesLabel')">
            <div class="flex min-w-0 flex-1 flex-col gap-1">
                <span class="body-small text-ink-muted">{{ t("chat.collaboration.viewer") }}</span>
                <span class="body-small-semibold break-words text-ink">{{
                    card.archetypes.viewer ?? (hasViewerPerspective ? t("chat.collaboration.archetypeUnavailable") : t("chat.collaboration.notAvailable"))
                }}</span>
            </div>
            <PairPerspectiveMark
                :viewer-archetype="card.archetypes.viewer"
                :colleague-archetype="card.archetypes.colleague"
                class="order-first col-span-2 h-12 w-20 justify-self-center @2xs/collaboration:order-none @2xs/collaboration:col-span-1" />
            <div class="flex min-w-0 flex-1 flex-col gap-1 text-right">
                <span class="body-small break-words text-ink-muted">{{ card.person_name ?? t("chat.collaboration.colleague") }}</span>
                <span class="body-small-semibold break-words text-ink">{{
                    card.archetypes.colleague ?? (hasColleaguePerspective ? t("chat.collaboration.archetypeUnavailable") : t("chat.collaboration.notAvailable"))
                }}</span>
            </div>
        </div>
        <p v-if="perspectiveSummary" class="body-small text-ink-muted">{{ perspectiveSummary }}</p>
        <p class="body-small text-ink-muted">{{ card.takeaway }}</p>
    </div>
</template>

<script setup lang="ts">
import type { CollaborationAnalysisCard } from "~vue/api/generated/collaboration-analysis";
import PairPerspectiveMark from "~vue/Connections/PairPerspectiveMark.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { card } = defineProps<{ card: CollaborationAnalysisCard }>();
const { t } = useI18n();
const hasViewerPerspective = computed(() => card.perspective_availability === "both" || card.perspective_availability === "viewer_only" || !!card.archetypes?.viewer);
const hasColleaguePerspective = computed(() => card.perspective_availability === "both" || card.perspective_availability === "colleague_only" || !!card.archetypes?.colleague);
const perspectiveSummary = computed(() => {
    const name = card.person_name ?? t("chat.collaboration.colleague");
    switch (card.perspective_availability) {
        case "viewer_only":
            return t("chat.collaboration.viewerOnly", { name });
        case "colleague_only":
            return t("chat.collaboration.colleagueOnly", { name });
        case "neither":
            return t("chat.collaboration.neitherPerspective");
        default:
            return null;
    }
});
</script>
